import { SET_MEETING_COMMAND, MEETING_CREATED_EVENT, CREATE_MEETING_COMMAND } from './actions';
import _ from 'lodash';
import { createDefaultMeetingInput } from './models';
import { LOCATION_CHANGE } from 'connected-react-router';
const loadInitialState = () => {
    return {
        inputMeeting: createDefaultMeetingInput(),
        creationInProgress: false
    };
};
export const meetingReducer = (state, action) => {
    if (!state)
        return loadInitialState();
    switch (action.type) {
        case SET_MEETING_COMMAND:
            return Object.assign(Object.assign({}, state), { inputMeeting: _.cloneDeep(action.meeting) });
        case CREATE_MEETING_COMMAND:
            return Object.assign(Object.assign({}, state), { creationInProgress: true });
        case MEETING_CREATED_EVENT:
            return Object.assign(Object.assign({}, state), { createdMeeting: action.meeting });
        case LOCATION_CHANGE:
            if (action.payload.location.pathname === '/createMeeting') {
                return Object.assign(Object.assign({}, state), { creationInProgress: false });
            }
        // falls through
        default:
            return state;
    }
};
